module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/audience/audience.component.css
// module id = ./src/app/audience/audience.component.css
// module chunks = main